import React from 'react';
const links = [{
  label: 'Impressum',
  href: '#impressum'
}, {
  label: 'Datenschutz',
  href: '#datenschutz'
}, {
  label: 'Nutzungsbedingungen',
  href: '#nutzungsbedingungen'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-130" data-mp="35chj3ypy1f09">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-131" data-mp="3f4duuckyd3my">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-132" data-mp="3k2p4am7c5c4n">
          Nail Educator Ready™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-133" data-mp="3o5lg9u2de9zm">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-134" data-mp="1tqso650p41cf">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-135" data-mp="o25sv7uuikt">
        © 2026 Nail Educator Ready™ — Deutsche Ausgabe. Digitale Lern- und Unterrichtsmaterialien für
        Nageldesign-Trainerinnen. Keine staatlich anerkannte Qualifikation oder Zertifizierung. Sichere Zahlung —
        abgewickelt in deiner Landeswährung.
      </p>
    </footer>;
}